/**
 * Labstep
 *
 * @module components/OrderRequest/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { OrderRequestActionDeleteProps } from './types';

export const OrderRequestActionDelete: React.FC<
  OrderRequestActionDeleteProps
> = ({ orderRequest }) => (
  <EntityActionDelete entity={orderRequest} />
);
